import React from 'react';
import styles from './styles.module.scss';
import { Button, TextField } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../i18n/LanguageProvider';

const PhoneNumber = ({ onSubmitPhone, loading }) => {
  const { t } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmitPhone(phoneNumber);
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        className={styles.formItem}
        fullWidth
        label={t('auth.phone')}
        id="phone"
        autoComplete="tel"
        type="tel"
        ltr
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        type="submit"
        disabled={loading}
      >
        {t('auth.confirmPhone')}
      </Button>
    </form>
  );
};

PhoneNumber.propTypes = {
  onSubmitPhone: PropTypes.func,
  loading: PropTypes.bool
};

export default PhoneNumber;
